module.exports = __webpack_public_path__ + "assets/img/ac4856.88443ee7.png";